import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { loadGA } from "@/lib/analytics";

const CONSENT_KEY = "bs_cookie_consent";

export const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(CONSENT_KEY);
    if (choice === "accepted") {
      loadGA();
    } else if (!choice) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    loadGA();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] rounded-2xl border border-slate-200 bg-white shadow-2xl p-5"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="flex items-start gap-3">
        <span className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-blue/10 text-brand-blue">
          <Cookie className="h-5 w-5" strokeWidth={2} />
        </span>
        <div>
          <p className="font-heading font-700 text-brand-navy">We value your privacy</p>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">
            We use Google Analytics to understand how our site is used. Analytics
            cookies are only set if you accept. See our{" "}
            <Link
              to="/privacy"
              className="text-brand-blue font-medium hover:underline"
            >
              Privacy &amp; Cookie Policy
            </Link>
            .
          </p>
        </div>
      </div>
      <div className="mt-4 flex items-center gap-3">
        <button
          data-testid="cookie-accept"
          onClick={accept}
          className="flex-1 inline-flex items-center justify-center bg-brand-navy text-white text-sm font-medium px-4 py-2.5 rounded-lg hover:bg-brand-navy-dark transition-colors"
        >
          Accept
        </button>
        <button
          data-testid="cookie-decline"
          onClick={decline}
          className="flex-1 inline-flex items-center justify-center bg-white text-slate-700 border border-slate-200 text-sm font-medium px-4 py-2.5 rounded-lg hover:bg-slate-50 transition-colors"
        >
          Decline
        </button>
      </div>
    </div>
  );
};
